<div class="d-flex align-items-center flex-column not-found">
	<uik-image-asset path="errors/error.svg" alt="Error page image"></uik-image-asset>
	<h1 class="mt-6 mat-h4" i18n="@@hub.page.not-found-title">Page introuvable</h1>
	<p class="mb-3 mat-body" i18n="@@hub.page.not-found-description">Cette page n'a pas été trouvée ou n'existe plus.</p>
	<button class="uik-body-semibold"
					matButton="elevated"
			color="primary"
			(click)="backHome()"
			i18n="@@hub.page.not-found-button">
		Retour à l'accueil
	</button>
</div>

